export default __webpack_public_path__ + "static/char-s-sp02-kr-bccc4841618ad63380352d74543e7566.webp";